export const url_pattern = /(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i
export const email_pattern = /\S+@\S+\.\S+/i
export const us_phone_number = /(1\s?)?[(]?\d{3}[)]?[(\s)?-]\d{3}[\s-]\d{4}/ig
export const example_phone_number = /555\s555\s5555/ig

export const isEmail = value => email_pattern.test(value)
export const isUrl = value => url_pattern.test(value)
export const isPhoneNumber = value => us_phone_number.test(value)
export const isExamplePhoneNumber = value => example_phone_number.test(value)

export const isUndefined = value => value === undefined
export const toBoolean = value => value === 'true'

export const isBooleanValue = value => typeof value === 'boolean'

export const ifStringEmpty = text => {
  if (text == null) return true
  text = text.trim()
  return text.length === 0 && !text.trim() && text.trim() !== ' '
}

export const checkBoolFromString = string => string === 'true'

export const nameValidation = text => {
  if (text == null) return true
  return text.length === 0
}

export function switchAttachmentType(fileType) {
  let type = 'null'
  if (
    fileType.includes([
      'jpeg',
      'png',
      'jpg',
      'jfif',
      'tiff',
      'gif',
      'bmp',
      'webp',
      'svg',
      'pnm',
    ])
  )
    type = 'image'
  else if (fileType.includes('pdf')) type = 'pdf'
  else if (
    fileType.includes([
      'avi',
      'mp4',
      'webm',
      'mkv',
      'flv',
      'vob',
      'm4p',
      '3gp',
      '3g2',
      'mpg',
      'mpeg',
    ])
  )
    type = 'video'
  else if (fileType.includes(['mp3', 'midi'])) type = 'audio'
  return type
}

export function handleIE() {
  return (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.documentMode === true
  ) //IF IE > 10
}

export function generatePostBackObject(object) {
  return generatePostBackObjectWithType(object, 'postback')
}

export function generatePostBackObjectWithType(object, type) {
  return {
    type: type,
    postback: {
      payload: object.payload,
      title: object.title,
    }
  }
}

export const zoomImage = (url, altText) => {
  window.parent.postMessage(
    {
      type: 'widget-fullscreen-image',
      imageUrl: url,
      altText
    }, '*'
  )
}

export function loadImage(url) {
  return new Promise(resolve => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.src = url
  })
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (const element of vars) {
    const pair = element.split('=')
    if (pair[0] === variable) {
      return decodeURI(pair[1])
    }
  }
  return false
}

export function getNestedProps(obj, path, def) {
  const fullPath = path
    .replace(/\[/g, '.')
    .replace(/]/g, '')
    .split('.')
    .filter(Boolean)

  return fullPath.every(everyFunc) ? obj : def

  function everyFunc(step) {
    // eslint-disable-next-line no-param-reassign
    return !(step && (obj = obj[step]) === undefined)
  }
}

export const saveActivePointToStorage = (chatHistoryLevel, storageKey, {questionnaireName}) => {
  switch (chatHistoryLevel) {
  case 'LOCAL_STORAGE':
    localStorage.setItem(storageKey, questionnaireName)
    break
  case 'SESSION_STORAGE':
    sessionStorage.setItem(storageKey, questionnaireName)
    break
  case 'NONE':
    removeStorageKeyFromBrowser(storageKey)
    break

  default:
    sessionStorage.setItem(storageKey, questionnaireName)
  }
}

export const getIframeSettingsFromBrowserByHistoryLevel = chatHistoryLevel => {
  switch (chatHistoryLevel) {
  case 'LOCAL_STORAGE':
    return {
      questionnaireName: localStorage.getItem('activeQuestionnaireName')
    }
  case 'SESSION_STORAGE':
    return {
      questionnaireName: sessionStorage.getItem('activeQuestionnaireName'),
    }
  case 'NONE':
    removeStorageKeyFromBrowser('activeQuestionnaireName')
    return null

  default:
    return null
  }
}

export function setIsIframeOpen(chatHistoryLevel, isIframeOpen) {
  if (chatHistoryLevel === 'LOCAL_STORAGE') {
    localStorage.setItem('widget-open-iframe', isIframeOpen)
  }
  if (chatHistoryLevel === 'SESSION_STORAGE') {
    sessionStorage.setItem('widget-open-iframe', isIframeOpen)
  }
}

export function getIsIframeOpen() {
  return localStorage.getItem('widget-open-iframe') || sessionStorage.getItem('widget-open-iframe')
}

export function getChatIdFromBrowserStorage() {
  return localStorage.getItem('widget-chatId') || sessionStorage.getItem('widget-chatId')
}

export const savePointNameToStorage = (chatHistoryLevel, {questionnaireName}, storageKey) => {
  const savedPassedQuestionnaires = getPassedPointsName(chatHistoryLevel, storageKey) || []
  questionnaireName && savedPassedQuestionnaires.push(questionnaireName)

  switch (chatHistoryLevel) {
  case 'LOCAL_STORAGE':
    localStorage.setItem(storageKey, JSON.stringify(savedPassedQuestionnaires))
    break
  case 'SESSION_STORAGE':
    sessionStorage.setItem(storageKey, JSON.stringify(savedPassedQuestionnaires))
    break

  default:
    sessionStorage.setItem(storageKey, JSON.stringify(savedPassedQuestionnaires))
  }
}

export const getPassedPointsName = (chatHistoryLevel, storageKey) => {
  switch (chatHistoryLevel) {
  case 'LOCAL_STORAGE':
    return JSON.parse(localStorage.getItem(storageKey))
  case 'SESSION_STORAGE':
    return JSON.parse(sessionStorage.getItem(storageKey))
  case 'NONE':
    removeStorageKeyFromBrowser(storageKey)
    return null

  default:
    return null
  }
}

export const isElementTop = el => el && !el.scrollTop

export const removeStorageKeyFromBrowser = (storageKey) => {
  localStorage.removeItem(storageKey)
  sessionStorage.removeItem(storageKey)
}

export function getBotMessage(message) {
  return {
    type: "text",
    text: message,
    isFromBot: true,
    rtl: false
  }
}

export function base64Utf16Decode(input) {
  const text = window.atob(input)
  const length = text.length
  const bytes = new Uint8Array(length)
  for (let i = 0; i < length; i++) {
    bytes[i] = text.charCodeAt(i)
  }
  const decoder = new TextDecoder('utf-16be')
  return decoder.decode(bytes)
}

export function sendUserEventToParent(event, additionalInfo) {
  window.parent.postMessage({
    type: 'user_event',
    userAction: event,
    additionalInfo
  }, '*')
}

export const parseAttributes = payload => {
  let base64Value

  try {
    const url = new URL(payload)
    base64Value = url.searchParams.get('attributes')
  } catch (e) {
    base64Value = payload?.split(';?attributes=')[1]
  }

  if (base64Value) {
    const base64DecodedValue = base64Utf16Decode(base64Value)
    return JSON.parse(base64DecodedValue)
  }
  return []
}

export const hasAttributeValue = (payload, attributeName, attributeValue) => {
    return parseAttributes(payload).some(item => item.name === attributeName && item.value === attributeValue)
}

export const findAttributeValue = (attributes, attributeName) => {
  return attributes?.find(attr => attr.name === attributeName)
}
